import { render, staticRenderFns } from "./customFieldBulkEdit.vue?vue&type=template&id=65dd9dbf&lang=pug"
import script from "./customFieldBulkEdit.vue?vue&type=script&lang=js"
export * from "./customFieldBulkEdit.vue?vue&type=script&lang=js"
import style0 from "./customFieldBulkEdit.vue?vue&type=style&index=0&id=65dd9dbf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports